module.exports = __webpack_public_path__ + "media/notice.579dd2ab.mp3";